//Funciones comunes del proceso de advisory
const endpointHelias = "https://9m4y8iz04h.execute-api.eu-west-3.amazonaws.com/prod"
const postListNearbyInstallers = endpointHelias+"/Helias/V0/Advisory/postListNearbyInstallers"
const postEmail = endpointHelias+'/Helias/V0/Messaging/postEmail'

var initialConfigCommonJS = require("../js/initialConfigCommon.js")
var generalCommonJS = require("../js/generalCommon.js")

exports.verificarConsejosAplicables = function(){

  try{
    
    var infoDashboard = JSON.parse(localStorage.getItem("lastDashboardData"))
    
    var tieneMonederoActivado = false
    var tieneBaterias = false

    if(Object.keys(infoDashboard.FVData).length > 0){         
      document.getElementById("advisoryFuentesAlternativasEnergia").className = document.getElementById("advisoryFuentesAlternativasEnergia").className.replaceAll(" hidden","") + " hidden"      
      if( infoDashboard.FVData.SolarWallet === "true"){
        tieneMonederoActivado = true
      }
    }
    else{
      document.getElementById("advisoryFuentesAlternativasEnergia").className = document.getElementById("advisoryFuentesAlternativasEnergia").className.replaceAll(" hidden","")      
    }

    if(Object.keys(infoDashboard.BatteriesData).length > 0){
      tieneBaterias = true
    }    

    if(tieneBaterias){         
      document.getElementById("advisoryBaterias").className = document.getElementById("advisoryBaterias").className.replaceAll(" hidden","") + " hidden"
    }
    else{
      if(Object.keys(infoDashboard.FVData).length > 0){  
        document.getElementById("advisoryBaterias").className = document.getElementById("advisoryBaterias").className.replaceAll(" hidden","")
      }
      else{
        document.getElementById("advisoryBaterias").className = document.getElementById("advisoryBaterias").className.replaceAll(" hidden","") + " hidden"
      }
    }
    
    if(tieneMonederoActivado && tieneBaterias){
      document.getElementById("advisoryAprovechamientoExcedenteEnergetico").className = document.getElementById("advisoryAprovechamientoExcedenteEnergetico").className.replaceAll(" hidden","") + " hidden"
    }
    else{
      if(Object.keys(infoDashboard.FVData).length > 0){  
        if(infoDashboard.InstallationData.GeneralInfo.EnergyGridConnected === "true"){
          document.getElementById("advisoryAprovechamientoExcedenteEnergetico").className = document.getElementById("advisoryAprovechamientoExcedenteEnergetico").className.replaceAll(" hidden","")
        }
        else{
          document.getElementById("advisoryAprovechamientoExcedenteEnergetico").className = document.getElementById("advisoryAprovechamientoExcedenteEnergetico").className.replaceAll(" hidden","") + " hidden"        
        }        
      }
      else{
        document.getElementById("advisoryAprovechamientoExcedenteEnergetico").className = document.getElementById("advisoryAprovechamientoExcedenteEnergetico").className.replaceAll(" hidden","") + " hidden"        
      }

    }

    if(infoDashboard.GeneralData.InstallationType.includes("PISO")){                        
      if(infoDashboard.InstallationData.GeneralInfo.EnergyGridConnected === "true"){
        document.getElementById("advisoryContratoLuz").className = document.getElementById("advisoryContratoLuz").className.replaceAll(" hidden","")        
        document.getElementById("advisoryAnalizadorTarifas").className = document.getElementById("advisoryAnalizadorTarifas").className.replaceAll(" hidden","")
      }      
      document.getElementById("advisorySustitucionElectrodomesticos").className = document.getElementById("advisorySustitucionElectrodomesticos").className.replaceAll(" hidden","")
      document.getElementById("advisoryControlConsumo").className = document.getElementById("advisoryControlConsumo").className.replaceAll(" hidden","")  
      document.getElementById("advisoryMediosAlternativosTransporte").className = document.getElementById("advisoryMediosAlternativosTransporte").className.replaceAll(" hidden","")
    }
    else if(infoDashboard.GeneralData.InstallationType.includes("CHALET")){          
      if(infoDashboard.InstallationData.GeneralInfo.EnergyGridConnected === "true"){
        document.getElementById("advisoryContratoLuz").className = document.getElementById("advisoryContratoLuz").className.replaceAll(" hidden","")        
        document.getElementById("advisoryAnalizadorTarifas").className = document.getElementById("advisoryAnalizadorTarifas").className.replaceAll(" hidden","")
      }      
      document.getElementById("advisorySustitucionElectrodomesticos").className = document.getElementById("advisorySustitucionElectrodomesticos").className.replaceAll(" hidden","")
      document.getElementById("advisoryControlConsumo").className = document.getElementById("advisoryControlConsumo").className.replaceAll(" hidden","")  
      document.getElementById("advisoryMediosAlternativosTransporte").className = document.getElementById("advisoryMediosAlternativosTransporte").className.replaceAll(" hidden","")  
    }
    else if(infoDashboard.GeneralData.InstallationType.includes("EMPRESA")){          
      if(infoDashboard.InstallationData.GeneralInfo.EnergyGridConnected === "true"){
        document.getElementById("advisoryContratoLuz").className = document.getElementById("advisoryContratoLuz").className.replaceAll(" hidden","")        
        document.getElementById("advisoryAnalizadorTarifas").className = document.getElementById("advisoryAnalizadorTarifas").className.replaceAll(" hidden","")
      }      
      document.getElementById("advisorySustitucionElectrodomesticos").className = document.getElementById("advisorySustitucionElectrodomesticos").className.replaceAll(" hidden","")
      document.getElementById("advisoryControlConsumo").className = document.getElementById("advisoryControlConsumo").className.replaceAll(" hidden","")     
      document.getElementById("advisoryMediosAlternativosTransporte").className = document.getElementById("advisoryMediosAlternativosTransporte").className.replaceAll(" hidden","")  
    }
    else if(infoDashboard.GeneralData.InstallationType.includes("COMUNIDAD")){  
      if(infoDashboard.InstallationData.GeneralInfo.EnergyGridConnected === "true"){
        document.getElementById("advisoryComunidadesVecinos").className = document.getElementById("advisoryComunidadesVecinos").className.replaceAll(" hidden","")          
        document.getElementById("advisoryAnalizadorTarifas").className = document.getElementById("advisoryAnalizadorTarifas").className.replaceAll(" hidden","")
      }              
      document.getElementById("advisorySustitucionElectrodomesticos").className = document.getElementById("advisorySustitucionElectrodomesticos").className.replaceAll(" hidden","")
      document.getElementById("advisoryControlConsumo").className = document.getElementById("advisoryControlConsumo").className.replaceAll(" hidden","")     
    }
  }
  catch(error){console.log(error)}


  // PROVISIONAL HASTA ACLARAR QUÉ HACEMOS CON EL ANALIZADOR DE TARIFAS.

  try{
    if(infoDashboard.GeneralData.InstallationType.includes("EMPRESA")){
      document.getElementById("advisoryAnalizadorTarifas").className = document.getElementById("advisoryAnalizadorTarifas").className.replaceAll(" hidden","") + " hidden"
    }
    else{
      document.getElementById("advisoryAnalizadorTarifas").className = document.getElementById("advisoryAnalizadorTarifas").className.replaceAll(" hidden","")
    }
  }
  catch(error){}

}

exports.mostrarInstaladoresCercanos = function(cadenaBusqueda, setObjListadoInstaladores){
    
  document.getElementById("divContenedorDetalleAdvisory").scrollTop = 0

  try{
    document.getElementById("divFormulario").className = document.getElementById("divFormulario").className.replaceAll(" hidden", "") + " hidden" 
  }
  catch(error){console.log(error)}
  document.getElementById("divTablaResultados").className = document.getElementById("divTablaResultados").className.replaceAll(" hidden", "") + " hidden" 
  document.getElementById("localizadorInstaladores").className = document.getElementById("localizadorInstaladores").className.replaceAll(" hidden", "")

  document.getElementById("loaderDetalleAdvisory").className="loader overlay"

  var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
  var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken")    

  var objDatosDashboard = JSON.parse(localStorage.getItem("lastDashboardData"))

  var jsonPeticion = {}

  //Petición de datos para el paso actual
  if(initialConfigCommonJS.existeSesion()){
    jsonPeticion = {
      "coordenadas": objDatosDashboard.MeteoData.InstallationLatitude+","+objDatosDashboard.MeteoData.InstallationLongitude, 
      "consulta": cadenaBusqueda.replaceAll(" ", "+")+"+"+objDatosDashboard.MeteoData.CityName.toLowerCase()
    }
  }
  else{
    jsonPeticion = {
      "coordenadas": document.getElementById("latitudInstalacion").value+","+document.getElementById("longitudInstalacion").value, 
      "consulta": cadenaBusqueda.replaceAll(" ", "+")+"+"+document.getElementById("direccion").value.toLowerCase()     
    }
  }

  // Guardo la información  
  var xhttp = new XMLHttpRequest();  
    xhttp.open("POST", postListNearbyInstallers, true);        
    xhttp.setRequestHeader('Content-Type', "application/json");
    xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);
    var data = JSON.stringify(jsonPeticion);
    xhttp.onreadystatechange = function() {
      if (this.readyState === 4 && this.status === 200) {
        var jsonRespuesta = JSON.parse(this.responseText)

        if(jsonRespuesta.statusCode === "403"){                   
          initialConfigCommonJS.mostrarMensajeInformativo("No tiene permisos para realizar la operación.","negative")
        }
        else{          
          //Si recibo datos ya configurados lo cargo  
          setObjListadoInstaladores(jsonRespuesta.body)
          
          document.getElementById("loaderDetalleAdvisory").className = "loader overlay hidden"

          //Si no hay datos configurados entonces no hago nada  
          console.log("Listado de instaladores cargado correctamente")
        }
      }

      if (this.readyState === 4 && this.status !== 200) {      
        initialConfigCommonJS.gestionarRespuestaPeticionErronea(this.status)          
      }
    }
    xhttp.send(data);      

}

exports.enviarResumenAnalisisFacturas = function(){

  document.getElementById("loaderGeneralAplicacion").className = document.getElementById("loaderGeneralAplicacion").className.replaceAll(" hidden", "") 

  var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
  var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken")       
  var jsonPeticion = {
    "mensaje": "helias@fevergy.com###Envio·Resumen·AnalisisFacturas",
    "origen": "RESUMEN_ANALISIS_12FACTURAS",
    "CUPS": document.getElementById("CUPSInstalacion").value.replaceAll(" ", "")
  }
  
  var xhttp = new XMLHttpRequest();  
    xhttp.open("POST", postEmail, true);        
    xhttp.setRequestHeader('Content-Type', "application/json");
    xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);
    var data = JSON.stringify(jsonPeticion);
    xhttp.onreadystatechange = function() {
      if (this.readyState === 4 && this.status === 200) {

        var jsonRespuesta = JSON.parse(this.responseText)

        if(jsonRespuesta.statusCode === "200"){
          initialConfigCommonJS.mostrarMensajeInformativo("Análisis enviado correctamente.","positive")
        }
        else{            
          initialConfigCommonJS.mostrarMensajeInformativo("Se produjo un error al enviar el análisis, vuelve a intentarlo.","negative")
        }

        document.getElementById("loaderGeneralAplicacion").className = document.getElementById("loaderGeneralAplicacion").className.replaceAll(" hidden", "") + " hidden"

      }
      else if (this.readyState === 4 && this.status !== 200) {
        initialConfigCommonJS.mostrarMensajeInformativo("Se produjo un error al enviar el análisis, vuelve a intentarlo.","negative")
        document.getElementById("loaderGeneralAplicacion").className = document.getElementById("loaderGeneralAplicacion").className.replaceAll(" hidden", "") + " hidden"
      }

    }
    xhttp.send(data);
  
}

exports.obtenerLiteralAccionPotencia = function(jsonRespuestaBody, tramo){

  var literalAccionPotencia = "Bajar"

  if(tramo === 1){
    if(jsonRespuestaBody.PowerAnalysis.NewPowerConfiguration.P1 === jsonRespuestaBody.Totals.PowerContracted.P1){
      literalAccionPotencia = "Dejar"
    }
  }
  else if(tramo === 2){
    if(jsonRespuestaBody.PowerAnalysis.NewPowerConfiguration.P2 === jsonRespuestaBody.Totals.PowerContracted.P2){
      literalAccionPotencia = "Dejar"
    }
  }
  else if(tramo === 3){
    if(jsonRespuestaBody.PowerAnalysis.NewPowerConfiguration.P3 === jsonRespuestaBody.Totals.PowerContracted.P3){
      literalAccionPotencia = "Dejar"
    }
  }
  else if(tramo === 4){
    if(jsonRespuestaBody.PowerAnalysis.NewPowerConfiguration.P4 === jsonRespuestaBody.Totals.PowerContracted.P4){
      literalAccionPotencia = "Dejar"
    }
  }
  else if(tramo === 5){
    if(jsonRespuestaBody.PowerAnalysis.NewPowerConfiguration.P5 === jsonRespuestaBody.Totals.PowerContracted.P5){
      literalAccionPotencia = "Dejar"
    }
  }
  else if(tramo === 6){
    if(jsonRespuestaBody.PowerAnalysis.NewPowerConfiguration.P6 === jsonRespuestaBody.Totals.PowerContracted.P6){
      literalAccionPotencia = "Dejar"
    }
  }

  return literalAccionPotencia
}

exports.procesarRespuestaVerificacion = function(jsonRespuesta){    

  //Si recibo datos ya configurados lo cargo  
  var numeroPotenciasConfiguradas = 0

  var valoresPotencias = Object.values(jsonRespuesta.body.Totals.PowerContracted)
  for(var x=0; x < valoresPotencias.length; x++){
    if( valoresPotencias[x] !== "0"){
      numeroPotenciasConfiguradas++      
    }
  }

  //Proceso la caja de ahorro por bajada de potencia            

  var textoPunta = "(Punta)"
  var textoValle = "(Valle)"

  if(numeroPotenciasConfiguradas > 2){
    textoPunta = ""
    textoValle = ""
  }
  

  if(jsonRespuesta.body.PowerAnalysis.ChangePower === "true"){           
    
    document.getElementById("divInstruccionesBajadaPotencia").className = document.getElementById("divInstruccionesBajadaPotencia").className.replaceAll(" hidden", "")                  
    document.getElementById("textoIntroBajadaPotencia").innerHTML = "Según los datos de tus últimos 2 años no necesitas tanta potencia contratada y estás pagando de más innecesariamente, bájala."
    
    document.getElementById("textoIntroBajadaPotencia").innerHTML = document.getElementById("textoIntroBajadaPotencia").innerHTML + " Para ello tienes que llamar a tu compañía actual y decirles que quieres:"
    document.getElementById("textoDetailBajadaPotencia").innerHTML = "Baja tu potencia contratada."

    document.getElementById("textoFinalSeccionPotencias").innerHTML = "Te cobrarán en torno a 10,95€ IVA Incluido, pero tranquil@ que esto ya lo hemos tenido en cuenta en tu ahorro. Luego espera un par de días a recibir el email o SMS de confirmación del cambio."
    
    document.getElementById("textoBajadaPotenciaP1").innerHTML = module.exports.obtenerLiteralAccionPotencia(jsonRespuesta.body, 1) + " la potencia en P1 "+textoPunta+" a "+new Intl.NumberFormat('en-DE').format(jsonRespuesta.body.PowerAnalysis.NewPowerConfiguration.P1)+" kW"
    document.getElementById("textoBajadaPotenciaP2").innerHTML = module.exports.obtenerLiteralAccionPotencia(jsonRespuesta.body, 2) + " la potencia en P2 "+textoValle+" a "+new Intl.NumberFormat('en-DE').format(jsonRespuesta.body.PowerAnalysis.NewPowerConfiguration.P2)+" kW"

    var ahorroEsteAño = new Intl.NumberFormat('en-DE').format(jsonRespuesta.body.PowerAnalysis.PowerSavingsBalance) 
    var ahorroSiguientesAños = new Intl.NumberFormat('en-DE').format( parseFloat(ahorroEsteAño) + parseFloat(jsonRespuesta.body.PowerAnalysis.ChangePowerFee))

    //document.getElementById("acordeonAhorroPotencias").className = document.getElementById("acordeonAhorroPotencias").className.replaceAll(" hidden", "")
    document.getElementById("textoIntroAhorroPotencia").innerHTML = "Bájala, este año ahorrarás "+ ahorroEsteAño.replaceAll("-","") +" €, en los sucesivos " + ahorroSiguientesAños.replaceAll("-","") + " € ya que la bajada de potencia sólo se cobra una vez."

    document.getElementById("trAhorroPotenciaP1").className = document.getElementById("trAhorroPotenciaP1").className.replaceAll(" hidden", "")              
    document.getElementById("trAhorroPotenciaP2").className = document.getElementById("trAhorroPotenciaP2").className.replaceAll(" hidden", "")              

    //Estas con 3.0 hay que ocultarlas
    if(numeroPotenciasConfiguradas === 6){
      document.getElementById("textoBajadaPotenciaP3").innerHTML = module.exports.obtenerLiteralAccionPotencia(jsonRespuesta.body, 3) + " la potencia en P3 a "+new Intl.NumberFormat('en-DE').format(jsonRespuesta.body.PowerAnalysis.NewPowerConfiguration.P3)+" kW"
      document.getElementById("textoBajadaPotenciaP4").innerHTML = module.exports.obtenerLiteralAccionPotencia(jsonRespuesta.body, 4) + " la potencia en P4 a "+new Intl.NumberFormat('en-DE').format(jsonRespuesta.body.PowerAnalysis.NewPowerConfiguration.P4)+" kW"
      document.getElementById("textoBajadaPotenciaP5").innerHTML = module.exports.obtenerLiteralAccionPotencia(jsonRespuesta.body, 5) + " la potencia en P5 a "+new Intl.NumberFormat('en-DE').format(jsonRespuesta.body.PowerAnalysis.NewPowerConfiguration.P5)+" kW"
      document.getElementById("textoBajadaPotenciaP6").innerHTML = module.exports.obtenerLiteralAccionPotencia(jsonRespuesta.body, 6) + " la potencia en P6 a "+new Intl.NumberFormat('en-DE').format(jsonRespuesta.body.PowerAnalysis.NewPowerConfiguration.P6)+" kW"
      
      document.getElementById("trAhorroPotenciaP3").className = document.getElementById("trAhorroPotenciaP3").className.replaceAll(" hidden", "")
      document.getElementById("trAhorroPotenciaP4").className = document.getElementById("trAhorroPotenciaP4").className.replaceAll(" hidden", "")
      document.getElementById("trAhorroPotenciaP5").className = document.getElementById("trAhorroPotenciaP5").className.replaceAll(" hidden", "")
      document.getElementById("trAhorroPotenciaP6").className = document.getElementById("trAhorroPotenciaP6").className.replaceAll(" hidden", "")
      
      document.getElementById("liTextoBajadaPotenciaP3").className = document.getElementById("liTextoBajadaPotenciaP3").className.replaceAll(" hidden", "")
      document.getElementById("liTextoBajadaPotenciaP4").className = document.getElementById("liTextoBajadaPotenciaP4").className.replaceAll(" hidden", "")
      document.getElementById("liTextoBajadaPotenciaP5").className = document.getElementById("liTextoBajadaPotenciaP5").className.replaceAll(" hidden", "")
      document.getElementById("liTextoBajadaPotenciaP6").className = document.getElementById("liTextoBajadaPotenciaP6").className.replaceAll(" hidden", "")
      
    }
    else{
      document.getElementById("trAhorroPotenciaP3").className = document.getElementById("trAhorroPotenciaP3").className.replaceAll(" hidden", "") + " hidden"
      document.getElementById("trAhorroPotenciaP4").className = document.getElementById("trAhorroPotenciaP4").className.replaceAll(" hidden", "") + " hidden"
      document.getElementById("trAhorroPotenciaP5").className = document.getElementById("trAhorroPotenciaP5").className.replaceAll(" hidden", "") + " hidden"
      document.getElementById("trAhorroPotenciaP6").className = document.getElementById("trAhorroPotenciaP6").className.replaceAll(" hidden", "") + " hidden"

      document.getElementById("liTextoBajadaPotenciaP3").className = document.getElementById("liTextoBajadaPotenciaP3").className.replaceAll(" hidden", "") + " hidden"
      document.getElementById("liTextoBajadaPotenciaP4").className = document.getElementById("liTextoBajadaPotenciaP4").className.replaceAll(" hidden", "") + " hidden"
      document.getElementById("liTextoBajadaPotenciaP5").className = document.getElementById("liTextoBajadaPotenciaP5").className.replaceAll(" hidden", "") + " hidden"
      document.getElementById("liTextoBajadaPotenciaP6").className = document.getElementById("liTextoBajadaPotenciaP6").className.replaceAll(" hidden", "") + " hidden"
    }
    
    
    document.getElementById("valorBalanceFinalAhorroPotenciaActual").innerHTML = new Intl.NumberFormat('en-DE').format(jsonRespuesta.body.PowerAnalysis.CurrentPowerTotalCost) + " €"
    document.getElementById("valorBalanceFinalAhorroPotenciaOferta").innerHTML = new Intl.NumberFormat('en-DE').format(jsonRespuesta.body.PowerAnalysis.NewPowerTotalCost) + " €"
    module.exports.setearColoresValorGasto("valorBalanceFinalAhorroPotencia", jsonRespuesta.body.PowerAnalysis.CurrentPowerTotalCost, jsonRespuesta.body.PowerAnalysis.NewPowerTotalCost)
    
    document.getElementById("valorAhorroPotenciaContratadaP1Actual").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Now.ContractedPowerCost.P1).toFixed(2)) + " €"
    document.getElementById("valorAhorroPotenciaContratadaP1Oferta").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.PowerAnalysis.NewPowerCostPerTimeframe.P1).toFixed(2)) + " €"            
    module.exports.setearColoresValorGasto("valorAhorroPotenciaContratadaP1", jsonRespuesta.body.Now.ContractedPowerCost.P1, jsonRespuesta.body.PowerAnalysis.NewPowerCostPerTimeframe.P1)              
    document.getElementById("potenciaP1Actual").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Totals.PowerContracted.P1).toFixed(2)) + " kW"
    document.getElementById("potenciaP1Oferta").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.PowerAnalysis.NewPowerConfiguration.P1).toFixed(2)) + " kW"            

    document.getElementById("valorAhorroPotenciaContratadaP2Actual").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Now.ContractedPowerCost.P2).toFixed(2)) + " €"
    document.getElementById("valorAhorroPotenciaContratadaP2Oferta").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.PowerAnalysis.NewPowerCostPerTimeframe.P2).toFixed(2)) + " €"            
    module.exports.setearColoresValorGasto("valorAhorroPotenciaContratadaP2", jsonRespuesta.body.Now.ContractedPowerCost.P2, jsonRespuesta.body.PowerAnalysis.NewPowerCostPerTimeframe.P2)              
    document.getElementById("potenciaP2Actual").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Totals.PowerContracted.P2).toFixed(2)) + " kW"
    document.getElementById("potenciaP2Oferta").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.PowerAnalysis.NewPowerConfiguration.P2).toFixed(2)) + " kW"            

    document.getElementById("valorAhorroPotenciaContratadaP3Actual").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Now.ContractedPowerCost.P3).toFixed(2)) + " €"
    document.getElementById("valorAhorroPotenciaContratadaP3Oferta").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.PowerAnalysis.NewPowerCostPerTimeframe.P3).toFixed(2)) + " €"            
    module.exports.setearColoresValorGasto("valorAhorroPotenciaContratadaP3", jsonRespuesta.body.Now.ContractedPowerCost.P3, jsonRespuesta.body.PowerAnalysis.NewPowerCostPerTimeframe.P3)              
    document.getElementById("potenciaP3Actual").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Totals.PowerContracted.P3).toFixed(2)) + " kW"
    document.getElementById("potenciaP3Oferta").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.PowerAnalysis.NewPowerConfiguration.P3).toFixed(2)) + " kW"            

    document.getElementById("valorAhorroPotenciaContratadaP4Actual").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Now.ContractedPowerCost.P4).toFixed(2)) + " €"
    document.getElementById("valorAhorroPotenciaContratadaP4Oferta").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.PowerAnalysis.NewPowerCostPerTimeframe.P4).toFixed(2)) + " €"            
    module.exports.setearColoresValorGasto("valorAhorroPotenciaContratadaP4", jsonRespuesta.body.Now.ContractedPowerCost.P4, jsonRespuesta.body.PowerAnalysis.NewPowerCostPerTimeframe.P4)              
    document.getElementById("potenciaP4Actual").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Totals.PowerContracted.P4).toFixed(2)) + " kW"
    document.getElementById("potenciaP4Oferta").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.PowerAnalysis.NewPowerConfiguration.P4).toFixed(2)) + " kW"            

    document.getElementById("valorAhorroPotenciaContratadaP5Actual").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Now.ContractedPowerCost.P5).toFixed(2)) + " €"
    document.getElementById("valorAhorroPotenciaContratadaP5Oferta").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.PowerAnalysis.NewPowerCostPerTimeframe.P5).toFixed(2)) + " €"            
    module.exports.setearColoresValorGasto("valorAhorroPotenciaContratadaP5", jsonRespuesta.body.Now.ContractedPowerCost.P5, jsonRespuesta.body.PowerAnalysis.NewPowerCostPerTimeframe.P5)              
    document.getElementById("potenciaP5Actual").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Totals.PowerContracted.P5).toFixed(2)) + " kW"
    document.getElementById("potenciaP5Oferta").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.PowerAnalysis.NewPowerConfiguration.P5).toFixed(2)) + " kW"            

    document.getElementById("valorAhorroPotenciaContratadaP6Actual").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Now.ContractedPowerCost.P6).toFixed(2)) + " €"
    document.getElementById("valorAhorroPotenciaContratadaP6Oferta").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.PowerAnalysis.NewPowerCostPerTimeframe.P6).toFixed(2)) + " €"            
    module.exports.setearColoresValorGasto("valorAhorroPotenciaContratadaP6", jsonRespuesta.body.Now.ContractedPowerCost.P6, jsonRespuesta.body.PowerAnalysis.NewPowerCostPerTimeframe.P6)              
    document.getElementById("potenciaP6Actual").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Totals.PowerContracted.P6).toFixed(2)) + " kW"
    document.getElementById("potenciaP6Oferta").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.PowerAnalysis.NewPowerConfiguration.P6).toFixed(2)) + " kW"            
    
    document.getElementById("costeBajadaPotenciaActual").innerHTML = "0 €"
    document.getElementById("costeBajadaPotenciaOferta").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.PowerAnalysis.ChangePowerFee).toFixed(2)) + " €"
    module.exports.setearColoresValorGasto("costeBajadaPotencia", "0", jsonRespuesta.body.PowerAnalysis.ChangePowerFee)              
    
    document.getElementById("ivaBajadaPotenciaActual").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.PowerAnalysis.CurrentPowerTaxes).toFixed(2)) + " €"
    document.getElementById("ivaBajadaPotenciaOferta").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.PowerAnalysis.NewPowerTaxes).toFixed(2)) + " €"
    module.exports.setearColoresValorGasto("ivaBajadaPotencia", jsonRespuesta.body.PowerAnalysis.CurrentPowerTaxes, jsonRespuesta.body.PowerAnalysis.NewPowerTaxes)              
    
    


  }
  else{
    //document.getElementById("acordeonAhorroPotencias").className = document.getElementById("acordeonAhorroPotencias").className.replaceAll(" hidden", "") + " hidden"
    document.getElementById("divInstruccionesBajadaPotencia").className = document.getElementById("divInstruccionesBajadaPotencia").className.replaceAll(" hidden", "")
    
    var potenciasContratadasAhora = jsonRespuesta.body.Totals.PowerContracted
    var faltaDePotenciaPorTramos = jsonRespuesta.body.PowerAnalysis.PowerLack.split("|")
    
    var nuevasPotenciasAContratar = [0,0,0,0,0,0]

    nuevasPotenciasAContratar[0] = parseFloat(potenciasContratadasAhora.P1) + parseFloat(faltaDePotenciaPorTramos[0].replaceAll("-",""))
    nuevasPotenciasAContratar[1] = parseFloat(potenciasContratadasAhora.P2) + parseFloat(faltaDePotenciaPorTramos[1].replaceAll("-",""))
    nuevasPotenciasAContratar[2] = parseFloat(potenciasContratadasAhora.P3) + parseFloat(faltaDePotenciaPorTramos[2].replaceAll("-",""))
    nuevasPotenciasAContratar[3] = parseFloat(potenciasContratadasAhora.P4) + parseFloat(faltaDePotenciaPorTramos[3].replaceAll("-",""))
    nuevasPotenciasAContratar[4] = parseFloat(potenciasContratadasAhora.P5) + parseFloat(faltaDePotenciaPorTramos[4].replaceAll("-",""))
    nuevasPotenciasAContratar[5] = parseFloat(potenciasContratadasAhora.P6) + parseFloat(faltaDePotenciaPorTramos[5].replaceAll("-",""))

    var faltaTotalPotencia = 0

    for(x=0; x<faltaDePotenciaPorTramos.length; x++){
      faltaTotalPotencia = faltaTotalPotencia + parseFloat(faltaDePotenciaPorTramos[x])
    }

    if(faltaTotalPotencia < 0){ //Le falta potencia
      document.getElementById("textoDetailBajadaPotencia").innerHTML = "Tienes menos potencia contratada de la que deberías."
      document.getElementById("textoIntroBajadaPotencia").innerHTML = "<p>Según los datos de tus últimos 2 años tienes menos potencia contratada de la que deberías, aun así <strong>no te recomendamos subirla</strong>.</p><p>&nbsp;</p>"
      document.getElementById("textoIntroBajadaPotencia").innerHTML = document.getElementById("textoIntroBajadaPotencia").innerHTML + "<p>Si te saltan los plomos pero de manera puntual te recomendamos que no cambies nada pero sí que instales un <strong>diferencial superinmunizado autorearmable</strong>. Te ahorrará bastantes disgustos, por ejemplo neveras descongeladas. Además cualquier electricista te lo instalará en pocos minutos por 120€ aproximadamente con mano de obra e IVA incluidos.</p><p>&nbsp;</p>" 
      document.getElementById("textoIntroBajadaPotencia").innerHTML = document.getElementById("textoIntroBajadaPotencia").innerHTML + "<p><strong>Sólo si te saltan los plomos constantemente te recomendamos subirla</strong>, en ese caso llama a tu actual compañía eléctrica y diles lo que quieres:</p>"

      var textoNombrePotencia = ""

      for(x=0; x<(nuevasPotenciasAContratar.length); x++){
        if(nuevasPotenciasAContratar[x] !== 0){

          if(x === 0){
            textoNombrePotencia = textoPunta
          }
          else if(x === 1){
            textoNombrePotencia = textoValle
          }
          else{
            textoNombrePotencia = ""
          }

          document.getElementById("textoBajadaPotenciaP"+(x+1)).innerHTML = "Subir la potencia en P"+(x+1)+" "+textoNombrePotencia+" a "+new Intl.NumberFormat('en-DE').format(nuevasPotenciasAContratar[x])+" kW"          
          document.getElementById("liTextoBajadaPotenciaP"+(x+1)).className = document.getElementById("liTextoBajadaPotenciaP"+(x+1)).className.replaceAll(" hidden", "")
        }
        else{
          document.getElementById("liTextoBajadaPotenciaP"+(x+1)).className = document.getElementById("liTextoBajadaPotenciaP"+(x+1)).className.replaceAll(" hidden", "") + " hidden"
        }
      }
      
      document.getElementById("textoFinalSeccionPotencias").innerHTML = "Te cobrarán en torno a 46€ por hacerlo y a partir de entonces pagarás más al mes en tu factura por dicho aumento de potencia."

    }
    else{ // No le falta potencia
      document.getElementById("textoDetailBajadaPotencia").innerHTML = "Tu potencia contratada está correcta, no la toques."
      document.getElementById("textoIntroBajadaPotencia").innerHTML = "Según los datos de tus últimos 2 años tienes contratada la potencia que necesitas y no más." 
      document.getElementById("liTextoBajadaPotenciaP1").className = document.getElementById("liTextoBajadaPotenciaP1").className.replaceAll(" hidden", "") + " hidden"
      document.getElementById("liTextoBajadaPotenciaP2").className = document.getElementById("liTextoBajadaPotenciaP2").className.replaceAll(" hidden", "") + " hidden"
      document.getElementById("liTextoBajadaPotenciaP3").className = document.getElementById("liTextoBajadaPotenciaP3").className.replaceAll(" hidden", "") + " hidden"
      document.getElementById("liTextoBajadaPotenciaP4").className = document.getElementById("liTextoBajadaPotenciaP4").className.replaceAll(" hidden", "") + " hidden"
      document.getElementById("liTextoBajadaPotenciaP5").className = document.getElementById("liTextoBajadaPotenciaP5").className.replaceAll(" hidden", "") + " hidden"
      document.getElementById("liTextoBajadaPotenciaP6").className = document.getElementById("liTextoBajadaPotenciaP6").className.replaceAll(" hidden", "") + " hidden"
      document.getElementById("textoFinalSeccionPotencias").innerHTML = ""
    }
    
  }

  //Ahora proceso la caja de ahorro por cambio de tarifa   

  if(numeroPotenciasConfiguradas === 6){ //3.0

    document.getElementById("trPotenciaP1").className = document.getElementById("trPotenciaP1").className.replaceAll(" hidden", "")
    document.getElementById("trPotenciaP2").className = document.getElementById("trPotenciaP2").className.replaceAll(" hidden", "")
    document.getElementById("trPotenciaP3").className = document.getElementById("trPotenciaP3").className.replaceAll(" hidden", "")
    document.getElementById("trPotenciaP4").className = document.getElementById("trPotenciaP4").className.replaceAll(" hidden", "")
    document.getElementById("trPotenciaP5").className = document.getElementById("trPotenciaP5").className.replaceAll(" hidden", "")
    document.getElementById("trPotenciaP6").className = document.getElementById("trPotenciaP6").className.replaceAll(" hidden", "")

    document.getElementById("trEnergiaP1").className = document.getElementById("trEnergiaP1").className.replaceAll(" hidden", "")
    document.getElementById("trEnergiaP2").className = document.getElementById("trEnergiaP2").className.replaceAll(" hidden", "")
    document.getElementById("trEnergiaP3").className = document.getElementById("trEnergiaP3").className.replaceAll(" hidden", "")
    document.getElementById("trEnergiaP4").className = document.getElementById("trEnergiaP4").className.replaceAll(" hidden", "")
    document.getElementById("trEnergiaP5").className = document.getElementById("trEnergiaP5").className.replaceAll(" hidden", "")
    document.getElementById("trEnergiaP6").className = document.getElementById("trEnergiaP6").className.replaceAll(" hidden", "")

  }
  else{ //2.0

    document.getElementById("trPotenciaP1").className = document.getElementById("trPotenciaP1").className.replaceAll(" hidden", "")
    document.getElementById("trPotenciaP2").className = document.getElementById("trPotenciaP2").className.replaceAll(" hidden", "")
    document.getElementById("trPotenciaP3").className = document.getElementById("trPotenciaP3").className.replaceAll(" hidden", "") + " hidden"
    document.getElementById("trPotenciaP4").className = document.getElementById("trPotenciaP4").className.replaceAll(" hidden", "") + " hidden"
    document.getElementById("trPotenciaP5").className = document.getElementById("trPotenciaP5").className.replaceAll(" hidden", "") + " hidden"
    document.getElementById("trPotenciaP6").className = document.getElementById("trPotenciaP6").className.replaceAll(" hidden", "") + " hidden"

    document.getElementById("trEnergiaP1").className = document.getElementById("trEnergiaP1").className.replaceAll(" hidden", "")
    document.getElementById("trEnergiaP2").className = document.getElementById("trEnergiaP2").className.replaceAll(" hidden", "")
    document.getElementById("trEnergiaP3").className = document.getElementById("trEnergiaP3").className.replaceAll(" hidden", "")
    document.getElementById("trEnergiaP4").className = document.getElementById("trEnergiaP4").className.replaceAll(" hidden", "") + " hidden"
    document.getElementById("trEnergiaP5").className = document.getElementById("trEnergiaP5").className.replaceAll(" hidden", "") + " hidden"
    document.getElementById("trEnergiaP6").className = document.getElementById("trEnergiaP6").className.replaceAll(" hidden", "") + " hidden"
  }


  
  try{
    document.getElementById("formularioTarifas").className = document.getElementById("formularioTarifas").className.replaceAll(" hidden", "")      
    document.getElementById("acordeonFormularioAnalisisTarifas").removeAttribute("open")
    document.getElementById("acordeonFormularioAnalisisTarifas").removeAttribute("disabled")        
  }
  catch(error){}
  document.getElementById("tablaResultadosInforme").className = document.getElementById("tablaResultadosInforme").className.replaceAll(" hidden", "")            
  document.getElementById("divImportesResultados").className = document.getElementById("divImportesResultados").className.replaceAll(" hidden", "")
                          
  if(jsonRespuesta.body.OfferInfo.InfoUrl === ""){                
    document.getElementById("aLinkOferta").className = document.getElementById("aLinkOferta").className.replaceAll(" hidden","") + " hidden"
  }
  else{
    document.getElementById("aLinkOferta").className = document.getElementById("aLinkOferta").className.replaceAll(" hidden","")
    //document.getElementById("aLinkOferta").innerHTML = jsonRespuesta.body.OfferInfo.FeeName + '<span class="material-icon">arrow_forward</span>'
    document.getElementById("aLinkOferta").href = jsonRespuesta.body.OfferInfo.InfoUrl              
    document.getElementById("nombreTarifa").innerHTML = jsonRespuesta.body.OfferInfo.FeeName              
  }
  
  //RESUMEN FINAL              
  document.getElementById("divBloqueOferta").className = document.getElementById("divBloqueOferta").className.replaceAll(" hidden", "")                        
  document.getElementById("textoIntroCalculos").innerHTML = "¿Quieres saber cómo hemos calculado tu ahorro? Aquí puedes verlo..."
  
  document.getElementById("textoResumenAhorroTotal").innerHTML = "Conseguirías un ahorro durante el próximo año de..."            

  document.getElementById("textoImporteAhorroTotalAño").innerHTML = new Intl.NumberFormat('en-DE').format(jsonRespuesta.body.AnalysisTotalSavings.replaceAll("-","")) + "€"
  document.getElementById("textoPorcentajeAhorroTotalAño").innerHTML = new Intl.NumberFormat('en-DE').format(jsonRespuesta.body.AnalysisPercentageSavings) + "%"

  if(jsonRespuesta.body.AnalysisPercentageSavings.includes("+")){
    document.getElementById("textoPorcentajeAhorroTotalAño").innerHTML = "+" + document.getElementById("textoPorcentajeAhorroTotalAño").innerHTML
  }
  
  //BALANCE FINAL Y MEDIA MENSUAL
  document.getElementById("valorBalanceFinalActual").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Now.BalanceTotal).toFixed(2)) + " €"
  document.getElementById("valorBalanceFinalOferta").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Offer.BalanceTotal).toFixed(2)) + " €"
  module.exports.setearColoresValorGasto("valorBalanceFinal", jsonRespuesta.body.Now.BalanceTotal, jsonRespuesta.body.Offer.BalanceTotal)

  if( (jsonRespuesta.body.Now.BalanceTotal > 0) && (jsonRespuesta.body.Offer.BalanceTotal > 0) ){
    document.getElementById("valorBalanceFinalActual").innerHTML = "+"+document.getElementById("valorBalanceFinalActual").innerHTML                
    document.getElementById("valorBalanceFinalOferta").innerHTML = "+"+document.getElementById("valorBalanceFinalOferta").innerHTML
  }
  else if ( (jsonRespuesta.body.Now.BalanceTotal < 0) && (jsonRespuesta.body.Offer.BalanceTotal > 0) ){
    document.getElementById("valorBalanceFinalActual").innerHTML = "-"+document.getElementById("valorBalanceFinalActual").innerHTML                
    document.getElementById("valorBalanceFinalOferta").innerHTML = "+"+document.getElementById("valorBalanceFinalOferta").innerHTML
  }
  else if ( (jsonRespuesta.body.Now.BalanceTotal > 0) && (jsonRespuesta.body.Offer.BalanceTotal < 0) ){
    document.getElementById("valorBalanceFinalActual").innerHTML = "+"+document.getElementById("valorBalanceFinalActual").innerHTML                
    document.getElementById("valorBalanceFinalOferta").innerHTML = "-"+document.getElementById("valorBalanceFinalOferta").innerHTML
  }
  else{
    //Lo dejo sin signo, que vendrían a ser importes negativos
  }

  document.getElementById("textoResumenAhorroTotal").innerHTML = "Aquí tienes tu ahorro para este año..."   

  var CUPS = jsonRespuesta.body.CUPS

  if(CUPS === undefined){
    CUPS = jsonRespuesta.CUPS
  }
  document.getElementById("textoCUPS").innerHTML = "Punto de suministro (CUPS): <strong>" + CUPS + "</strong>"
  
  if( (jsonRespuesta.body.Offer.BalanceTotal > 0) ){
    document.getElementById("literalTotales").innerHTML = "Tendrás algunas facturas 0 € y ganarás dinero"   
  }  
  else{
    document.getElementById("literalTotales").innerHTML = "Total gasto análisis"                
  }

  document.getElementById("acordeonCalculosResultados").className = document.getElementById("acordeonCalculosResultados").className.replaceAll(" hidden", "")           

  if(jsonRespuesta.body.AnalysisPercentageSavings.includes("+")){
    document.getElementById("mensajeComentarioContrataSolarSinPaneles").innerHTML = "Ganarías más que ahora, "
  }
  else{
    document.getElementById("mensajeComentarioContrataSolarSinPaneles").innerHTML = "Ahorrarías dinero, "
  }
  
  document.getElementById("divImportesResultados").className = document.getElementById("divImportesResultados").className.replaceAll(" hidden", "")
  document.getElementById("divBloqueOferta").className = document.getElementById("divBloqueOferta").className.replaceAll(" hidden", "")  

  if( (!jsonRespuesta.body.Totals.InstallationType.includes("FV")) && (jsonRespuesta.body.OfferInfo.FeeName.toLowerCase().includes("solar")) ){ 
    document.getElementById("mensajeComentarioContrataSolarSinPaneles").className = document.getElementById("mensajeComentarioContrataSolarSinPaneles").className.replaceAll(" hidden", "")                
  }
  else{
    document.getElementById("mensajeComentarioContrataSolarSinPaneles").className = document.getElementById("mensajeComentarioContrataSolarSinPaneles").className.replaceAll(" hidden", "") + " hidden"            
  }

  if(jsonRespuesta.body.Totals.DecissionCode === "FA_WALLET_POSITIVE"){
    document.getElementById("mensajeComentarioContrataSolarSinPaneles").className = document.getElementById("mensajeComentarioContrataSolarSinPaneles").className.replaceAll(" hidden", "") 
    
    if(jsonRespuesta.body.Totals.InstallationType.includes("FV")){
      document.getElementById("mensajeComentarioContrataSolarSinPaneles").innerHTML = document.getElementById("mensajeComentarioContrataSolarSinPaneles").innerHTML + "aunque aunque todavía tienes saldo en el monedero solar. Yo me esperaría a gastarlo antes de cambiarme, tu decides..."
    }
    else{
      document.getElementById("mensajeComentarioContrataSolarSinPaneles").innerHTML = document.getElementById("mensajeComentarioContrataSolarSinPaneles").innerHTML + "aunque aunque todavía tienes saldo de bonificaciones con tu actual compañía. Yo me esperaría a gastarlo antes de cambiarme, tu decides..."
    }
    

  }
  else{    
    document.getElementById("mensajeComentarioContrataSolarSinPaneles").className = document.getElementById("mensajeComentarioContrataSolarSinPaneles").className.replaceAll(" hidden", "") + " hidden"
  }

  //POTENCIA              
  document.getElementById("potenciaContratadaP1Actual").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Totals.PowerContracted.P1).toFixed(2)) + " kW"                          
  if(jsonRespuesta.body.PowerAnalysis.ChangePower === "true"){
    document.getElementById("potenciaContratadaP1Oferta").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.PowerAnalysis.NewPowerConfiguration.P1).toFixed(2)) + " kW"              
  }
  else{
    document.getElementById("potenciaContratadaP1Oferta").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Totals.PowerContracted.P1).toFixed(2)) + " kW"              
  }
  document.getElementById("valorPotenciaContratadaP1Actual").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Now.ContractedPowerCost.P1).toFixed(2)) + " €"
  document.getElementById("valorPotenciaContratadaP1Oferta").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Offer.ContractedPowerCost.P1).toFixed(2)) + " €"
  module.exports.setearColoresValorGasto("valorPotenciaContratadaP1", jsonRespuesta.body.Now.ContractedPowerCost.P1, jsonRespuesta.body.Offer.ContractedPowerCost.P1)            
  document.getElementById("tarifaPotenciaP1Actual").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Now.ContractedPowerFee.P1).toFixed(3)) + " €"
  document.getElementById("tarifaPotenciaP1Oferta").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Offer.ContractedPowerFee.P1).toFixed(3)) + " €"
  
  document.getElementById("potenciaContratadaP2Actual").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Totals.PowerContracted.P2).toFixed(2)) + " kW"              
  if(jsonRespuesta.body.PowerAnalysis.ChangePower === "true"){
    document.getElementById("potenciaContratadaP2Oferta").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.PowerAnalysis.NewPowerConfiguration.P2).toFixed(2)) + " kW"              
  }
  else{
    document.getElementById("potenciaContratadaP2Oferta").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Totals.PowerContracted.P2).toFixed(2)) + " kW"              
  }
  document.getElementById("valorPotenciaContratadaP2Actual").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Now.ContractedPowerCost.P2).toFixed(2)) + " €"
  document.getElementById("valorPotenciaContratadaP2Oferta").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Offer.ContractedPowerCost.P2).toFixed(2)) + " €"
  module.exports.setearColoresValorGasto("valorPotenciaContratadaP2", jsonRespuesta.body.Now.ContractedPowerCost.P2, jsonRespuesta.body.Offer.ContractedPowerCost.P2)            
  document.getElementById("tarifaPotenciaP2Actual").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Now.ContractedPowerFee.P2).toFixed(3)) + " €"
  document.getElementById("tarifaPotenciaP2Oferta").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Offer.ContractedPowerFee.P2).toFixed(3)) + " €"

  document.getElementById("potenciaContratadaP3Actual").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Totals.PowerContracted.P3).toFixed(2)) + " kW"              
  if(jsonRespuesta.body.PowerAnalysis.ChangePower === "true"){
    document.getElementById("potenciaContratadaP3Oferta").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.PowerAnalysis.NewPowerConfiguration.P3).toFixed(2)) + " kW"              
  }
  else{
    document.getElementById("potenciaContratadaP3Oferta").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Totals.PowerContracted.P3).toFixed(2)) + " kW"              
  }            
  document.getElementById("valorPotenciaContratadaP3Actual").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Now.ContractedPowerCost.P3).toFixed(2)) + " €"
  document.getElementById("valorPotenciaContratadaP3Oferta").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Offer.ContractedPowerCost.P3).toFixed(2)) + " €"
  module.exports.setearColoresValorGasto("valorPotenciaContratadaP3", jsonRespuesta.body.Now.ContractedPowerCost.P3, jsonRespuesta.body.Offer.ContractedPowerCost.P3)
  document.getElementById("tarifaPotenciaP3Actual").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Now.ContractedPowerFee.P3).toFixed(3)) + " €"
  document.getElementById("tarifaPotenciaP3Oferta").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Offer.ContractedPowerFee.P3).toFixed(3)) + " €"

  document.getElementById("potenciaContratadaP4Actual").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Totals.PowerContracted.P4).toFixed(2)) + " kW"              
  if(jsonRespuesta.body.PowerAnalysis.ChangePower === "true"){
    document.getElementById("potenciaContratadaP4Oferta").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.PowerAnalysis.NewPowerConfiguration.P4).toFixed(2)) + " kW"              
  }
  else{
    document.getElementById("potenciaContratadaP4Oferta").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Totals.PowerContracted.P4).toFixed(2)) + " kW"              
  }
  document.getElementById("valorPotenciaContratadaP4Actual").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Now.ContractedPowerCost.P4).toFixed(2)) + " €"
  document.getElementById("valorPotenciaContratadaP4Oferta").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Offer.ContractedPowerCost.P4).toFixed(2)) + " €"
  module.exports.setearColoresValorGasto("valorPotenciaContratadaP4", jsonRespuesta.body.Now.ContractedPowerCost.P4, jsonRespuesta.body.Offer.ContractedPowerCost.P4)
  document.getElementById("tarifaPotenciaP4Actual").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Now.ContractedPowerFee.P4).toFixed(3)) + " €"
  document.getElementById("tarifaPotenciaP4Oferta").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Offer.ContractedPowerFee.P4).toFixed(3)) + " €"

  document.getElementById("potenciaContratadaP5Actual").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Totals.PowerContracted.P5).toFixed(2)) + " kW"     
  if(jsonRespuesta.body.PowerAnalysis.ChangePower === "true"){
    document.getElementById("potenciaContratadaP5Oferta").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.PowerAnalysis.NewPowerConfiguration.P5).toFixed(2)) + " kW"              
  }
  else{
    document.getElementById("potenciaContratadaP5Oferta").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Totals.PowerContracted.P5).toFixed(2)) + " kW"              
  }         
  document.getElementById("valorPotenciaContratadaP5Actual").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Now.ContractedPowerCost.P5).toFixed(2)) + " €"
  document.getElementById("valorPotenciaContratadaP5Oferta").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Offer.ContractedPowerCost.P5).toFixed(2)) + " €"
  module.exports.setearColoresValorGasto("valorPotenciaContratadaP5", jsonRespuesta.body.Now.ContractedPowerCost.P5, jsonRespuesta.body.Offer.ContractedPowerCost.P5)
  document.getElementById("tarifaPotenciaP5Actual").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Now.ContractedPowerFee.P5).toFixed(3)) + " €"
  document.getElementById("tarifaPotenciaP5Oferta").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Offer.ContractedPowerFee.P5).toFixed(3)) + " €"

  document.getElementById("potenciaContratadaP6Actual").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Totals.PowerContracted.P6).toFixed(2)) + " kW"     
  if(jsonRespuesta.body.PowerAnalysis.ChangePower === "true"){
    document.getElementById("potenciaContratadaP6Oferta").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.PowerAnalysis.NewPowerConfiguration.P6).toFixed(2)) + " kW"              
  }
  else{
    document.getElementById("potenciaContratadaP6Oferta").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Totals.PowerContracted.P6).toFixed(2)) + " kW"              
  }         
  document.getElementById("valorPotenciaContratadaP6Actual").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Now.ContractedPowerCost.P6).toFixed(2)) + " €"
  document.getElementById("valorPotenciaContratadaP6Oferta").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Offer.ContractedPowerCost.P6).toFixed(2)) + " €"
  module.exports.setearColoresValorGasto("valorPotenciaContratadaP6", jsonRespuesta.body.Now.ContractedPowerCost.P6, jsonRespuesta.body.Offer.ContractedPowerCost.P6)
  document.getElementById("tarifaPotenciaP6Actual").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Now.ContractedPowerFee.P6).toFixed(3)) + " €"
  document.getElementById("tarifaPotenciaP6Oferta").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Offer.ContractedPowerFee.P6).toFixed(3)) + " €"
  
  //ENERGÍA
  if(jsonRespuesta.body.Totals.BoughtEnergy.P1 > 1000){
    document.getElementById("consumoEnergiaP1").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Totals.BoughtEnergy.P1/1000).toFixed(2)) + " MWh"                
  }
  else{
    document.getElementById("consumoEnergiaP1").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Totals.BoughtEnergy.P1).toFixed(2)) + " kWh"
  }
  document.getElementById("valorEnergiaP1Actual").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Now.EnergyCost.P1).toFixed(2)) + " €"
  document.getElementById("valorEnergiaP1Oferta").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Offer.EnergyCost.P1).toFixed(2)) + " €"
  module.exports.setearColoresValorGasto("valorEnergiaP1", jsonRespuesta.body.Now.EnergyCost.P1, jsonRespuesta.body.Offer.EnergyCost.P1)

  document.getElementById("tarifaEnergiaP1Actual").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Now.EnergyFee.P1).toFixed(3)) + " €"
  document.getElementById("tarifaEnergiaP1Oferta").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Offer.EnergyFee.P1).toFixed(3)) + " €"
  

  if(jsonRespuesta.body.Totals.BoughtEnergy.P2 > 1000){
    document.getElementById("consumoEnergiaP2").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Totals.BoughtEnergy.P2/1000).toFixed(2)) + " MWh"                
  }
  else{
    document.getElementById("consumoEnergiaP2").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Totals.BoughtEnergy.P2).toFixed(2)) + " kWh"
  }
  document.getElementById("valorEnergiaP2Actual").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Now.EnergyCost.P2).toFixed(2)) + " €"
  document.getElementById("valorEnergiaP2Oferta").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Offer.EnergyCost.P2).toFixed(2)) + " €"
  module.exports.setearColoresValorGasto("valorEnergiaP2", jsonRespuesta.body.Now.EnergyCost.P2, jsonRespuesta.body.Offer.EnergyCost.P2)

  document.getElementById("tarifaEnergiaP2Actual").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Now.EnergyFee.P2).toFixed(3)) + " €"
  document.getElementById("tarifaEnergiaP2Oferta").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Offer.EnergyFee.P2).toFixed(3)) + " €"

  if(jsonRespuesta.body.Totals.BoughtEnergy.P3 > 1000){
    document.getElementById("consumoEnergiaP3").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Totals.BoughtEnergy.P3/1000).toFixed(2)) + " MWh"                
  }
  else{
    document.getElementById("consumoEnergiaP3").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Totals.BoughtEnergy.P3).toFixed(2)) + " kWh"
  }
  document.getElementById("valorEnergiaP3Actual").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Now.EnergyCost.P3).toFixed(2)) + " €"
  document.getElementById("valorEnergiaP3Oferta").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Offer.EnergyCost.P3).toFixed(2)) + " €"
  module.exports.setearColoresValorGasto("valorEnergiaP3", jsonRespuesta.body.Now.EnergyCost.P3, jsonRespuesta.body.Offer.EnergyCost.P3)

  document.getElementById("tarifaEnergiaP3Actual").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Now.EnergyFee.P3).toFixed(3)) + " €"
  document.getElementById("tarifaEnergiaP3Oferta").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Offer.EnergyFee.P3).toFixed(3)) + " €"

  if(jsonRespuesta.body.Totals.BoughtEnergy.P4 > 1000){
    document.getElementById("consumoEnergiaP4").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Totals.BoughtEnergy.P4/1000).toFixed(2)) + " MWh"                
  }
  else{
    document.getElementById("consumoEnergiaP4").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Totals.BoughtEnergy.P4).toFixed(2)) + " kWh"
  }
  document.getElementById("valorEnergiaP4Actual").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Now.EnergyCost.P4).toFixed(2)) + " €"
  document.getElementById("valorEnergiaP4Oferta").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Offer.EnergyCost.P4).toFixed(2)) + " €"
  module.exports.setearColoresValorGasto("valorEnergiaP4", jsonRespuesta.body.Now.EnergyCost.P4, jsonRespuesta.body.Offer.EnergyCost.P4)

  document.getElementById("tarifaEnergiaP4Actual").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Now.EnergyFee.P4).toFixed(3)) + " €"
  document.getElementById("tarifaEnergiaP4Oferta").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Offer.EnergyFee.P4).toFixed(3)) + " €"

  if(jsonRespuesta.body.Totals.BoughtEnergy.P5 > 1000){
    document.getElementById("consumoEnergiaP5").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Totals.BoughtEnergy.P5/1000).toFixed(2)) + " MWh"                
  }
  else{
    document.getElementById("consumoEnergiaP5").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Totals.BoughtEnergy.P5).toFixed(2)) + " kWh"
  }
  document.getElementById("valorEnergiaP5Actual").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Now.EnergyCost.P5).toFixed(2)) + " €"
  document.getElementById("valorEnergiaP5Oferta").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Offer.EnergyCost.P5).toFixed(2)) + " €"
  module.exports.setearColoresValorGasto("valorEnergiaP5", jsonRespuesta.body.Now.EnergyCost.P5, jsonRespuesta.body.Offer.EnergyCost.P5)

  document.getElementById("tarifaEnergiaP5Actual").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Now.EnergyFee.P5).toFixed(3)) + " €"
  document.getElementById("tarifaEnergiaP5Oferta").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Offer.EnergyFee.P5).toFixed(3)) + " €"

  if(jsonRespuesta.body.Totals.BoughtEnergy.P6 > 1000){
    document.getElementById("consumoEnergiaP6").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Totals.BoughtEnergy.P6/1000).toFixed(2)) + " MWh"                
  }
  else{
    document.getElementById("consumoEnergiaP6").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Totals.BoughtEnergy.P6).toFixed(2)) + " kWh"
  }
  document.getElementById("valorEnergiaP6Actual").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Now.EnergyCost.P6).toFixed(2)) + " €"
  document.getElementById("valorEnergiaP6Oferta").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Offer.EnergyCost.P6).toFixed(2)) + " €"
  module.exports.setearColoresValorGasto("valorEnergiaP6", jsonRespuesta.body.Now.EnergyCost.P6, jsonRespuesta.body.Offer.EnergyCost.P6)

  document.getElementById("tarifaEnergiaP6Actual").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Now.EnergyFee.P6).toFixed(3)) + " €"
  document.getElementById("tarifaEnergiaP6Oferta").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Offer.EnergyFee.P6).toFixed(3)) + " €"

  //EXCEDENTE
  if(jsonRespuesta.body.Totals.SoldEnergy > 1000){
    document.getElementById("valorExcedente").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Totals.SoldEnergy/1000).toFixed(2)) + " MWh"                
  }
  else{
    document.getElementById("valorExcedente").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Totals.SoldEnergy).toFixed(2)) + " kWh"
  }

  document.getElementById("valorExcedenteActual").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Now.EnergyRevenue.SoldEnergy).toFixed(2)) + " €"
  document.getElementById("tarifaExcedenteActual").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Now.EnergyRevenue.SurplusFee).toFixed(3))            

  document.getElementById("valorExcedenteOferta").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Offer.EnergyRevenue.SoldEnergy).toFixed(2)) + " €"
  document.getElementById("tarifaExcedenteOferta").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Offer.EnergyRevenue.SurplusFee).toFixed(3))              


  module.exports.setearColoresValorGasto("valorExcedente", jsonRespuesta.body.Now.EnergyRevenue.SoldEnergy, jsonRespuesta.body.Offer.EnergyRevenue.SoldEnergy)

  var tieneFotovoltaica = false

  if(jsonRespuesta.body.Totals.SoldEnergy > 0){
    tieneFotovoltaica = true
  }

  if(tieneFotovoltaica){ //Tiene fotovoltaica                
    document.getElementById("trExcedente").className = document.getElementById("trExcedente").className.replaceAll(" hidden","")
  }
  else{
    document.getElementById("trExcedente").className = document.getElementById("trExcedente").className.replaceAll(" hidden","") + " hidden"
  }

  //DESCUENTO
  var descuentosAhora = parseFloat(jsonRespuesta.body.Now.EnergyRevenue.Discounts).toFixed(2)
  var descuentosOferta = parseFloat(jsonRespuesta.body.Offer.EnergyRevenue.Discounts).toFixed(2)

  if((descuentosAhora > 0) || (descuentosOferta > 0)){
    document.getElementById("trDescuentos").className = document.getElementById("trDescuentos").className.replaceAll(" hidden","")
    document.getElementById("valorDescuentoActual").innerHTML = new Intl.NumberFormat('en-DE').format(descuentosAhora) + " €"
    document.getElementById("valorDescuentoOferta").innerHTML = new Intl.NumberFormat('en-DE').format(descuentosOferta) + " €"
    module.exports.setearColoresValorGasto("valorDescuento", jsonRespuesta.body.Now.EnergyRevenue.Discounts, jsonRespuesta.body.Offer.EnergyRevenue.Discounts)
  }
  else{
    document.getElementById("trDescuentos").className = document.getElementById("trDescuentos").className.replaceAll(" hidden","") + " hidden"
  }

  var labelTextoBonificacion = ""

  if( (parseFloat(jsonRespuesta.body.Offer.EnergyRevenue.Bonus) > 0) || isNaN(parseFloat(jsonRespuesta.body.Offer.EnergyRevenue.Bonus)) ){    

    if( (jsonRespuesta.body.Totals.DecissionCode === "FA_CHANGE") || (jsonRespuesta.body.Totals.DecissionCode === "FA_UP2U") ){
      document.getElementById("bubblePromocionOferta").className = document.getElementById("bubblePromocionOferta").className.replaceAll(" hidden", "")
    }
    else{
      document.getElementById("bubblePromocionOferta").className = document.getElementById("bubblePromocionOferta").className.replaceAll(" hidden", "") + " hidden"
    }              

    if(jsonRespuesta.body.Offer.EnergyRevenue.BonusType.toLowerCase() === "referido"){

      if(jsonRespuesta.body.OfferInfo.FeeName.toLowerCase().includes("octopus")){
        labelTextoBonificacion = 'Y si conoces a alguien con Octopus y usas su enlace de referido <strong>te bonificarán con '+jsonRespuesta.body.Offer.EnergyRevenue.Bonus+' € adicionales</strong> a lo indicado arriba. Si no conoces a nadie <a href="'+jsonRespuesta.body.OfferInfo.ReferralUrl+'" target="_blank" rel="noopener noreferrer" class="link inline-link">puedes usar este enlace de referido</a>.'
      }
      else{
        module.exports.enviarEmailBonificacionNoControlada("Oferta con bonificación no controlada: "+ jsonRespuesta.body.OfferInfo.FeeName + " ,valor: " + jsonRespuesta.body.Offer.EnergyRevenue.Bonus + " , tipo:"+jsonRespuesta.body.Offer.EnergyRevenue.BonusType)                    
      }

    }
    else if(jsonRespuesta.body.Offer.EnergyRevenue.BonusType.toLowerCase() === "MES_GRATIS"){      
      labelTextoBonificacion = 'Con esta tarifa <strong>el primer mes te saldrá gratis</strong>.'      
    }
    else if(jsonRespuesta.body.Offer.EnergyRevenue.BonusType.toLowerCase() === "nueva_alta"){

      if( (jsonRespuesta.body.OfferInfo.FeeName.toLowerCase().includes("nufri")) && (jsonRespuesta.body.OfferInfo.FeeName.toLowerCase().includes("3 precios")) ){
        labelTextoBonificacion = 'Estas tarifas son para nuevas altas, recuerda comentar el código de promoción <strong>'+jsonRespuesta.body.Offer.EnergyRevenue.Bonus+'</strong> para que te apliquen las tarifas correctas.'
      }
      else{
        module.exports.enviarEmailBonificacionNoControlada("Oferta con bonificación no controlada: "+ jsonRespuesta.body.OfferInfo.FeeName + " ,valor: " + jsonRespuesta.body.Offer.EnergyRevenue.Bonus + " , tipo:"+jsonRespuesta.body.Offer.EnergyRevenue.BonusType)                    
      }

    }
    else if(jsonRespuesta.body.Offer.EnergyRevenue.BonusType.toLowerCase() === "directo"){

      if(jsonRespuesta.body.OfferInfo.FeeName.toLowerCase().includes("octopus")){
        labelTextoBonificacion = 'Y si conoces a alguien con Octopus y usas su enlace de referido <strong>te bonificarán con '+jsonRespuesta.body.Offer.EnergyRevenue.Bonus+' € adicionales</strong> a lo indicado arriba. Si no conoces a nadie <a href="'+jsonRespuesta.body.OfferInfo.ReferralUrl+'" target="_blank" rel="noopener noreferrer" class="link inline-link">puedes usar este enlace de referido</a>.'
      }
      else{
        module.exports.enviarEmailBonificacionNoControlada("Oferta con bonificación no controlada: "+ jsonRespuesta.body.OfferInfo.FeeName + " ,valor: " + jsonRespuesta.body.Offer.EnergyRevenue.Bonus + " , tipo:"+jsonRespuesta.body.Offer.EnergyRevenue.BonusType)                    
      }

    }
    else if(jsonRespuesta.body.Offer.EnergyRevenue.BonusType.toLowerCase() === "gasolina"){                  
      labelTextoBonificacion = "Y además si contratas esta tarifa <strong>te bonificarán con "+jsonRespuesta.body.Offer.EnergyRevenue.Bonus+" € adicionales en gasolina</strong>"
    }
    else{
      module.exports.enviarEmailBonificacionNoControlada("Oferta con bonificación no controlada: "+ jsonRespuesta.body.OfferInfo.FeeName + " ,valor: " + jsonRespuesta.body.Offer.EnergyRevenue.Bonus + " , tipo:"+jsonRespuesta.body.Offer.EnergyRevenue.BonusType)
    }
                  
    document.getElementById("labelTextoBonificacion").className = document.getElementById("labelTextoBonificacion").className.replaceAll(" hidden","") 
    document.getElementById("labelTextoBonificacion").innerHTML = labelTextoBonificacion
                  
  }
  else{

    document.getElementById("bubblePromocionOferta").className = document.getElementById("bubblePromocionOferta").className.replaceAll(" hidden", "") + " hidden"

    if(jsonRespuesta.body.Offer.EnergyRevenue.BonusType === "MERCADO_REGULADO"){ 
      labelTextoBonificacion = "Al ser una tarifa de mercado regulado <strong>da igual con quien la contrates, todas deberían darte las mismas condiciones</strong>. Pulsa en el botón para ver las comercializadoras existentes."
      document.getElementById("labelTextoBonificacion").className = document.getElementById("labelTextoBonificacion").className.replaceAll(" hidden","") 
      document.getElementById("labelTextoBonificacion").innerHTML = labelTextoBonificacion
    }
    else{
      document.getElementById("labelTextoBonificacion").className = document.getElementById("labelTextoBonificacion").className.replaceAll(" hidden","") + " hidden"
    }
    
  }            

  if(jsonRespuesta.body.OfferInfo.FeeName.toLowerCase().includes("som energia")){
    document.getElementById("bubblePromocionOferta").className = document.getElementById("bubblePromocionOferta").className.replaceAll(" hidden", "")
    document.getElementById("labelTextoBonificacion").className = document.getElementById("labelTextoBonificacion").className.replaceAll(" hidden","") 
    labelTextoBonificacion = 'Som Energia es una cooperativa y te pedirán darte de alta como socio por 100€, pero tranquil@ que no hay permanencia y cuando decidas irte te los devolverán.'
    document.getElementById("labelTextoBonificacion").innerHTML = labelTextoBonificacion
  }

  if( (document.getElementById("trDescuentos").className.includes("hidden")) && (document.getElementById("trExcedente").className.includes("hidden")) ){
    document.getElementById("divBonificaciones").className = document.getElementById("divBonificaciones").className.replaceAll(" hidden","") + " hidden"
  }
  else{
    document.getElementById("divBonificaciones").className = document.getElementById("divBonificaciones").className.replaceAll(" hidden","")
  }              

  //OTROS GASTOS

  document.getElementById("valorEquiposMedicionActual").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Now.EquipmentHiring).toFixed(2)) + " €"
  document.getElementById("valorEquiposMedicionOferta").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Offer.EquipmentHiring).toFixed(2)) + " €"
  module.exports.setearColoresValorGasto("valorEquiposMedicion", jsonRespuesta.body.Now.EquipmentHiring, jsonRespuesta.body.Offer.EquipmentHiring)

  var valorCosteMonederoAhora = parseFloat(jsonRespuesta.body.Now.SolarWallet).toFixed(2)
  var valorCosteMonederoOferta = parseFloat(jsonRespuesta.body.Offer.SolarWallet).toFixed(2)

  document.getElementById("valorMonederoSolarActual").innerHTML = new Intl.NumberFormat('en-DE').format(valorCosteMonederoAhora) + " €"
  document.getElementById("valorMonederoSolarOferta").innerHTML = new Intl.NumberFormat('en-DE').format(valorCosteMonederoOferta) + " €"
  module.exports.setearColoresValorGasto("valorMonederoSolar", jsonRespuesta.body.Now.SolarWallet, jsonRespuesta.body.Offer.SolarWallet)

  if(tieneFotovoltaica){ //Tiene fotovoltaica            
    
    if( (valorCosteMonederoAhora < 0) || (valorCosteMonederoAhora < 0) ){
      document.getElementById("trGastosFijosMonederoSolar").className = document.getElementById("trGastosFijosMonederoSolar").className.replaceAll(" hidden","")
    }
    else{
      document.getElementById("trGastosFijosMonederoSolar").className = document.getElementById("trGastosFijosMonederoSolar").className.replaceAll(" hidden","") + " hidden"
    }

    
  }
  else{
    document.getElementById("trGastosFijosMonederoSolar").className = document.getElementById("trGastosFijosMonederoSolar").className.replaceAll(" hidden","") + " hidden"
  }

  var comisionCompañiaAhora = parseFloat(jsonRespuesta.body.Now.MonthlyCompanyFee).toFixed(2)
  var comisionCompañiaOferta = parseFloat(jsonRespuesta.body.Offer.MonthlyCompanyFee).toFixed(2)
  
  if( (comisionCompañiaAhora < 0) || (comisionCompañiaOferta < 0) ){
    document.getElementById("trGastosComisionMensualCompañia").className = document.getElementById("trGastosComisionMensualCompañia").className.replaceAll(" hidden","")
    document.getElementById("valorComisionFijaCompañiaActual").innerHTML = new Intl.NumberFormat('en-DE').format(comisionCompañiaAhora) + " €"
    document.getElementById("valorComisionFijaCompañiaOferta").innerHTML = new Intl.NumberFormat('en-DE').format(comisionCompañiaOferta) + " €"
    module.exports.setearColoresValorGasto("valorComisionFijaCompañia", jsonRespuesta.body.Now.MonthlyCompanyFee, jsonRespuesta.body.Offer.MonthlyCompanyFee)
  }
  else{
    document.getElementById("trGastosComisionMensualCompañia").className = document.getElementById("trGastosComisionMensualCompañia").className.replaceAll(" hidden","") + " hidden"
  }

  if(jsonRespuesta.body.PowerAnalysis.ChangePower === "true"){    
    document.getElementById("trCosteBajadaPotenciaAnalisisTarifas").className = document.getElementById("trCosteBajadaPotenciaAnalisisTarifas").className.replaceAll(" hidden","")
    document.getElementById("valorCosteBajadaPotenciaActual").innerHTML = "0 €"
    document.getElementById("valorCosteBajadaPotenciaOferta").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.PowerAnalysis.ChangePowerFee).toFixed(2)) + " €"
    module.exports.setearColoresValorGasto("valorCosteBajadaPotencia", "0", jsonRespuesta.body.PowerAnalysis.ChangePowerFee)
  }
  else{
    document.getElementById("trCosteBajadaPotenciaAnalisisTarifas").className = document.getElementById("trCosteBajadaPotenciaAnalisisTarifas").className.replaceAll(" hidden","") + " hidden"
  }

  //IMPUESTOS

  document.getElementById("valorBonoSocialActual").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Now.SocialBonus).toFixed(2)) + " €"
  document.getElementById("valorBonoSocialOferta").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Offer.SocialBonus).toFixed(2)) + " €"
  module.exports.setearColoresValorGasto("valorBonoSocial", jsonRespuesta.body.Now.SocialBonus, jsonRespuesta.body.Offer.SocialBonus)

  document.getElementById("valorImpuestoElectricidadActual").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Now.ElectricityTax).toFixed(2)) + " €"
  document.getElementById("valorImpuestoElectricidadOferta").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Offer.ElectricityTax).toFixed(2)) + " €"
  module.exports.setearColoresValorGasto("valorImpuestoElectricidad", jsonRespuesta.body.Now.ElectricityTax, jsonRespuesta.body.Offer.ElectricityTax)

  document.getElementById("importeIVAActual").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Now.IVA).toFixed(2)) + " €"
  document.getElementById("importeIVAOferta").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Offer.IVA).toFixed(2)) + " €"
  module.exports.setearColoresValorGasto("importeIVA", jsonRespuesta.body.Now.IVA, jsonRespuesta.body.Offer.IVA)

  document.getElementById("valorComisionFEVERGYActual").innerHTML = "0 €"
  document.getElementById("valorComisionFEVERGYOferta").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.PowerAnalysis.FEVERGYFee).toFixed(2)) + " €"
  document.getElementById("spanTextoHonorariosFEVERGY").innerHTML = "Honorarios FEVERGY"  
  module.exports.setearColoresValorGasto("valorComisionFEVERGY", "0", jsonRespuesta.body.PowerAnalysis.FEVERGYFee)

}

exports.setearColoresValorGasto = function(campo, valorCampoActual, valorCampoOferta){
    
  if( (document.getElementById(campo+"Actual") !== null) && (document.getElementById(campo+"Oferta") !== null) ){

    if ( parseFloat(valorCampoActual) === parseFloat(valorCampoOferta) ){                  
      document.getElementById(campo+"Actual").style="color: #00CCCC;" //Cyan
      document.getElementById(campo+"Oferta").style="color: #00CCCC;" //Cyan
    }      
    else if ( parseFloat(valorCampoActual) < parseFloat(valorCampoOferta) ){                  
        document.getElementById(campo+"Actual").style="color: var(--red-300)" //Rojo oscuro
        document.getElementById(campo+"Oferta").style="color: var(--green-300)"  // Verde
    }
    else{
      document.getElementById(campo+"Actual").style="color: var(--green-300)"  // Verde
      document.getElementById(campo+"Oferta").style="color: var(--red-300)" //Rojo oscuro
    }

    document.getElementById(campo+"Actual").innerHTML = document.getElementById(campo+"Actual").innerHTML.replaceAll("-","")
    document.getElementById(campo+"Oferta").innerHTML = document.getElementById(campo+"Oferta").innerHTML.replaceAll("-","")
        
  }

}

exports.setearColoresValorBonificacion = function(campo, valorCampoActual, valorCampoOferta){
    
  if( (document.getElementById(campo+"Actual") !== null) && (document.getElementById(campo+"Oferta") !== null) ){
    
    if ( parseFloat(valorCampoActual) === parseFloat(valorCampoOferta) ){                  
      document.getElementById(campo+"Actual").style="color: #00CCCC;" //Cyan
      document.getElementById(campo+"Oferta").style="color: #00CCCC;" //Cyan
    }      
    else if ( parseFloat(valorCampoActual) < parseFloat(valorCampoOferta) ){                  
        document.getElementById(campo+"Actual").style="color: var(--red-300)" //Rojo oscuro
        document.getElementById(campo+"Oferta").style="color: var(--green-300)"  // Verde
    }
    else{
      document.getElementById(campo+"Actual").style="color: var(--green-300)"  // Verde
      document.getElementById(campo+"Oferta").style="color: var(--red-300)" //Rojo oscuro
    }
    
    if(valorCampoActual > 0){
      document.getElementById(campo+"Actual").innerHTML = "+"+document.getElementById(campo+"Actual").innerHTML
    }
    
    if(valorCampoOferta > 0){
      document.getElementById(campo+"Oferta").innerHTML = "+"+document.getElementById(campo+"Oferta").innerHTML
    }

    //document.getElementById(campo).style="color: #FFC300;" //Mostaza
    //document.getElementById(campo).style="color: var(--green-300)"  
    //document.getElementById(campo).style="color: #00CCCC;" //Cyan
    
  }

}

exports.enviarEmailBonificacionNoControlada = function(mensaje){

  //Petición de datos para el paso actual
  var jsonPeticion = {            
    "mensaje": generalCommonJS.obtenerEmailUsuario()+"###"+mensaje,      
    "origen": "WEB"
  }

  // Guardo la información  
  var xhttp = new XMLHttpRequest();  
    xhttp.open("POST", postEmail, true);        
    xhttp.setRequestHeader('Content-Type', "application/json");      
    var data = JSON.stringify(jsonPeticion);
    xhttp.onreadystatechange = function() {
      if (this.readyState === 4 && this.status === 200) {
        var jsonRespuesta = JSON.parse(this.responseText)

        if(jsonRespuesta.statusCode === "403"){                   
          initialConfigCommonJS.mostrarMensajeInformativo("Se ha producido un error al enviar el mensaje, vuelve a intentarlo en unos minutos.","negative")
        }
        else{          
          //Email aviso enviado
        }

      }

      if (this.readyState === 4 && this.status !== 200) {      
        initialConfigCommonJS.gestionarRespuestaPeticionErronea(this.status)          
      }
    }
    xhttp.send(data);    

}
